var cov_2hyv9diw4g = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/errors.ts",
      hash = "9889ac692b9472148d4eb2a25fd32ed50215a146",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/errors.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 11
        }
      },
      "1": {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 26
        }
      },
      "2": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 26
        }
      },
      "3": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 22
        }
      },
      "4": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 18,
          column: 3
        }
      },
      "5": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 39
        }
      },
      "6": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 21,
          column: 3
        }
      },
      "7": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 43
        }
      },
      "8": {
        start: {
          line: 20,
          column: 26
        },
        end: {
          line: 20,
          column: 42
        }
      },
      "9": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 14
        }
      },
      "10": {
        start: {
          line: 25,
          column: 26
        },
        end: {
          line: 36,
          column: 4
        }
      },
      "11": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 36,
          column: 4
        }
      },
      "12": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 35,
          column: 8
        }
      },
      "13": {
        start: {
          line: 29,
          column: 22
        },
        end: {
          line: 29,
          column: 47
        }
      },
      "14": {
        start: {
          line: 29,
          column: 36
        },
        end: {
          line: 29,
          column: 46
        }
      },
      "15": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 31,
          column: 26
        }
      },
      "16": {
        start: {
          line: 30,
          column: 19
        },
        end: {
          line: 30,
          column: 32
        }
      },
      "17": {
        start: {
          line: 31,
          column: 13
        },
        end: {
          line: 31,
          column: 26
        }
      },
      "18": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 45
        }
      },
      "19": {
        start: {
          line: 38,
          column: 27
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "20": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 39,
          column: 26
        }
      },
      "21": {
        start: {
          line: 39,
          column: 15
        },
        end: {
          line: 39,
          column: 26
        }
      },
      "22": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 42,
          column: 3
        }
      },
      "23": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 34
        }
      },
      "24": {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 43,
          column: 16
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 4,
            column: 3
          }
        },
        loc: {
          start: {
            line: 4,
            column: 59
          },
          end: {
            line: 9,
            column: 3
          }
        },
        line: 4
      },
      "1": {
        name: "wrapFormError",
        decl: {
          start: {
            line: 15,
            column: 16
          },
          end: {
            line: 15,
            column: 29
          }
        },
        loc: {
          start: {
            line: 15,
            column: 64
          },
          end: {
            line: 23,
            column: 1
          }
        },
        line: 15
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 20,
            column: 21
          },
          end: {
            line: 20,
            column: 22
          }
        },
        loc: {
          start: {
            line: 20,
            column: 26
          },
          end: {
            line: 20,
            column: 42
          }
        },
        line: 20
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 25,
            column: 26
          },
          end: {
            line: 25,
            column: 27
          }
        },
        loc: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 36,
            column: 4
          }
        },
        line: 26
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 26,
            column: 14
          },
          end: {
            line: 26,
            column: 15
          }
        },
        loc: {
          start: {
            line: 26,
            column: 35
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 26
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 28,
            column: 12
          },
          end: {
            line: 28,
            column: 13
          }
        },
        loc: {
          start: {
            line: 28,
            column: 19
          },
          end: {
            line: 32,
            column: 7
          }
        },
        line: 28
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 29,
            column: 31
          },
          end: {
            line: 29,
            column: 32
          }
        },
        loc: {
          start: {
            line: 29,
            column: 36
          },
          end: {
            line: 29,
            column: 46
          }
        },
        line: 29
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 33,
            column: 13
          },
          end: {
            line: 33,
            column: 14
          }
        },
        loc: {
          start: {
            line: 33,
            column: 18
          },
          end: {
            line: 35,
            column: 7
          }
        },
        line: 33
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 38,
            column: 27
          },
          end: {
            line: 38,
            column: 28
          }
        },
        loc: {
          start: {
            line: 38,
            column: 55
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 38
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 7,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 7,
            column: 20
          }
        }, {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 26
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        }, {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        }],
        line: 16
      },
      "2": {
        loc: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        }, {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        }],
        line: 19
      },
      "3": {
        loc: {
          start: {
            line: 25,
            column: 48
          },
          end: {
            line: 25,
            column: 61
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 25,
            column: 57
          },
          end: {
            line: 25,
            column: 61
          }
        }],
        line: 25
      },
      "4": {
        loc: {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 31,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 31,
            column: 26
          }
        }, {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 31,
            column: 26
          }
        }],
        line: 30
      },
      "5": {
        loc: {
          start: {
            line: 34,
            column: 15
          },
          end: {
            line: 34,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 34,
            column: 24
          },
          end: {
            line: 34,
            column: 40
          }
        }, {
          start: {
            line: 34,
            column: 43
          },
          end: {
            line: 34,
            column: 44
          }
        }],
        line: 34
      },
      "6": {
        loc: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 26
          }
        }, {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 26
          }
        }],
        line: 39
      },
      "7": {
        loc: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        }, {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        }],
        line: 40
      },
      "8": {
        loc: {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 24
          }
        }, {
          start: {
            line: 40,
            column: 28
          },
          end: {
            line: 40,
            column: 46
          }
        }],
        line: 40
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

export var FormError =
/*#__PURE__*/
function (_Error) {
  _inherits(FormError, _Error);

  var _super = _createSuper2(FormError);

  function FormError(message, name, value) {
    var _this;

    _classCallCheck(this, FormError);

    cov_2hyv9diw4g.f[0]++;
    cov_2hyv9diw4g.s[0]++;
    _this = _super.call(this);
    _this.value = void 0;
    cov_2hyv9diw4g.s[1]++;
    _this.message = message;
    cov_2hyv9diw4g.s[2]++;
    _this.name = (cov_2hyv9diw4g.b[0][0]++, name) || (cov_2hyv9diw4g.b[0][1]++, '');
    cov_2hyv9diw4g.s[3]++;
    _this.value = value;
    return _this;
  }

  return FormError;
}(
/*#__PURE__*/
_wrapNativeSuper(Error));
export function wrapFormError(error) {
  cov_2hyv9diw4g.f[1]++;
  cov_2hyv9diw4g.s[4]++;

  if (error instanceof Error) {
    cov_2hyv9diw4g.b[1][0]++;
    cov_2hyv9diw4g.s[5]++;
    return new FormError(error.message);
  } else {
    cov_2hyv9diw4g.b[1][1]++;
  }

  cov_2hyv9diw4g.s[6]++;

  if (Array.isArray(error)) {
    cov_2hyv9diw4g.b[2][0]++;
    cov_2hyv9diw4g.s[7]++;
    return error.map(function (e) {
      cov_2hyv9diw4g.f[2]++;
      cov_2hyv9diw4g.s[8]++;
      return wrapFormError(e);
    });
  } else {
    cov_2hyv9diw4g.b[2][1]++;
  }

  cov_2hyv9diw4g.s[9]++;
  return error;
}
cov_2hyv9diw4g.s[10]++;
export var promiseAll = function promiseAll(ops) {
  var isForm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_2hyv9diw4g.b[3][0]++, true);
  cov_2hyv9diw4g.f[3]++;
  cov_2hyv9diw4g.s[11]++;
  return new Promise(function (resolve, reject) {
    cov_2hyv9diw4g.f[4]++;
    cov_2hyv9diw4g.s[12]++;
    Promise.all(ops).then(function (res) {
      cov_2hyv9diw4g.f[5]++;
      var error = (cov_2hyv9diw4g.s[13]++, res.find(function (r) {
        cov_2hyv9diw4g.f[6]++;
        cov_2hyv9diw4g.s[14]++;
        return r !== true;
      }));
      cov_2hyv9diw4g.s[15]++;

      if (error) {
        cov_2hyv9diw4g.b[4][0]++;
        cov_2hyv9diw4g.s[16]++;
        reject(error);
      } else {
        cov_2hyv9diw4g.b[4][1]++;
        cov_2hyv9diw4g.s[17]++;
        resolve(true);
      }
    })["catch"](function (e) {
      cov_2hyv9diw4g.f[7]++;
      cov_2hyv9diw4g.s[18]++;
      reject(isForm ? (cov_2hyv9diw4g.b[5][0]++, wrapFormError(e)) : (cov_2hyv9diw4g.b[5][1]++, e));
    });
  });
};
cov_2hyv9diw4g.s[19]++;
export var isSameError = function isSameError(a, b) {
  cov_2hyv9diw4g.f[8]++;
  cov_2hyv9diw4g.s[20]++;

  if (a === b) {
    cov_2hyv9diw4g.b[6][0]++;
    cov_2hyv9diw4g.s[21]++;
    return true;
  } else {
    cov_2hyv9diw4g.b[6][1]++;
  }

  cov_2hyv9diw4g.s[22]++;

  if ((cov_2hyv9diw4g.b[8][0]++, a instanceof Error) && (cov_2hyv9diw4g.b[8][1]++, b instanceof Error)) {
    cov_2hyv9diw4g.b[7][0]++;
    cov_2hyv9diw4g.s[23]++;
    return a.message === b.message;
  } else {
    cov_2hyv9diw4g.b[7][1]++;
  }

  cov_2hyv9diw4g.s[24]++;
  return a === b;
};